import { daggerBadge } from "../../icons"
import "./spinning-logo.component.css"

const SpinningLogoComponent = (props) => {
  return (
    <div className="dagger-spinning-logo">
      {!props.isLoading && daggerBadge}
      {props.isLoading && (
        <video autoPlay muted playsInline loop>
          <source src="/3d-logo-pro-1.mov" type="video/quicktime" />
          <source src="/3d-logo.webm" type="video/webm" />
        </video>
      )}
    </div>
  )
}

export default SpinningLogoComponent
